
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forget-password/forget-password.lazy",
      function () {
        return require("private-next-pages/forget-password/forget-password.lazy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forget-password/forget-password.lazy"])
      });
    }
  